import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UNLEASH_TOGGLES} from '@app/config/FeatureToggleConfig';
import {DcpProductDataService} from '@app/product/data/dcp-product-data.service';
import {NumberFormattingService} from '@app/services/formatting/number-formatting.service';
import {DcpExtendedMetric, DcpMetric, FeatureTogglesService} from '@dcp/configurator';
import {UntilDestroy, untilDestroyed} from '@ngneat/until-destroy';
import {Product} from '@spartacus/core';
import {distinctUntilChanged} from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'dcp-metric-text',
  templateUrl: './metric-text.component.html',
})
export class MetricTextComponent implements OnInit {

  public salesUnit: string;
  public blocksOfMetric: DcpExtendedMetric;
  public blocksOfMetricFormattedAmount: string;
  public salesMetric: DcpMetric;

  public tooltipToggleIsEnabled: boolean;

  @Input()
  public quantity: number;

  @Input()
  set product(value: Product) {
    this.salesUnit = value?.unit?.name;
    this.blocksOfMetric = this.dcpProductDataService.getBlocksOf(value?.data);
    this.blocksOfMetricFormattedAmount = this.numberFormattingService.formatAmount(this.blocksOfMetric?.amount);
    this.salesMetric = this.dcpProductDataService.getSalesMetric(value?.data);
  }

  constructor(
    private dcpProductDataService: DcpProductDataService,
    private numberFormattingService: NumberFormattingService,
    public route: ActivatedRoute,
    private togglesService: FeatureTogglesService,
    private cdr: ChangeDetectorRef,
  ) {
  }

  ngOnInit(): void {
    this.subscribeToFeatureToggles();
  }

  subscribeToFeatureToggles() {
    this.togglesService.isEnabled(UNLEASH_TOGGLES.showQuantityTooltip).pipe(distinctUntilChanged(), untilDestroyed(this))
      .subscribe((isEnabled) => {
        this.tooltipToggleIsEnabled = isEnabled;
        this.cdr.detectChanges();
      });
  }
}
